import React, { Children, FC, ReactElement, Component, useEffect } from 'react';
import {Alert} from './AlertComponent';
import Xsvg from '../components/Xsvg';

interface ErrorProps {
  message: string;
  severity: string;
  display: boolean;
  onClose: ()=>void;
}

const ErrorMessage: FC<ErrorProps> = (errorProps: ErrorProps) => {
  const { message, severity, display, onClose } = errorProps;


  return (
    display && (
      <div className="AlertMessageWrapper">
        <Alert size="small" severity={severity} variant="open" heading={message} closable="true" onClose={onClose} />
      </div>
    )
  );
};

export default ErrorMessage;
